// src/oura/whatsnew/WhatsNewBar.tsx
//
// A slim bar across the top of every staff Oura page with one line and a link
// to the page that explains the release (Jack, 4 Nov 2026). Closes with the X
// and stays closed in this browser; a new entry in notes.ts shows again.

import { useState } from "react";
import { ArrowUpRightIcon, SparklesIcon, XIcon } from "lucide-react";
import { useOuraRole } from "../role";
import { cn } from "../lib/cn";
import { FOCUS_RING, TYPE } from "@oura/ui";
import { close, currentNote } from "./notes";

export function WhatsNewBar() {
    const staff = useOuraRole() === "oura-staff";
    const [note, setNote] = useState(() => currentNote());
    if (!staff || !note) return null;
    const dismiss = () => {
        close(note.id);
        setNote(null);
    };
    return (
        <div role="status" data-whats-new={note.id} className="flex items-center gap-3 border-b border-blue-100 bg-blue-50 px-4 py-2 md:px-8">
            <SparklesIcon aria-hidden size={16} className="shrink-0 text-blue-600" />
            <p className={cn(TYPE.tb, "m-0 min-w-0 flex-1 truncate text-gray-900")}>{note.line}</p>
            <a
                href={note.href}
                target="_blank"
                rel="noreferrer"
                className={cn(TYPE.tb, FOCUS_RING, "inline-flex shrink-0 items-center gap-1 rounded font-medium text-blue-600 hover:underline")}
            >
                See what&apos;s new
                <ArrowUpRightIcon aria-hidden size={14} />
            </a>
            <button
                type="button"
                onClick={dismiss}
                aria-label="Close this note"
                title="Close"
                className={cn(FOCUS_RING, "shrink-0 rounded p-1 text-gray-500 transition-colors hover:bg-blue-100 hover:text-gray-900")}
            >
                <XIcon aria-hidden size={16} />
            </button>
        </div>
    );
}
